import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import React from 'react';
import { classes, st } from './MultiSelect.st.css';
import './MultiSelect.responsive.st.css';
import BaseComp from 'wix-style-react/dist/es/src/MultiSelect/MultiSelect';
import WixStyleReactProvider from 'wix-style-react/dist/es/src/WixStyleReactProvider/WixStyleReactProvider';
var SIZES = {
  large: 'medium',
  medium: 'small',
  small: 'tiny'
};
var MultiSelect = function MultiSelect(_ref) {
  var className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var size = SIZES[rest.size];
  return /*#__PURE__*/React.createElement(WixStyleReactProvider, {
    features: {
      newColorsBranding: true
    }
  }, /*#__PURE__*/React.createElement(BaseComp, _extends({
    className: st(classes.root, className),
    size: size
  }, rest)));
};
MultiSelect.displayName = 'MultiSelect';
export default MultiSelect;